<template>
    <div class="d-flex align-center flex-column ">
        <v-card>
            <s-toolbar label="Orden de Compra" dark color="#8e8f91" close @close="$emit('close')"></s-toolbar>
            <v-card-title style="font-size: small;">
                <v-row>
                    <v-col align="right">
                        <v-tooltip bottom="">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" fab x-small color="info" @click="downloadPdf()">
                                    <v-icon medium>mdi-printer</v-icon>
                                </v-btn>
                            </template>
                            <span>Imprimir Orden de Compra</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-card-title>

            <hr>
            <v-container style="padding: 25px;">
                <vue-html2pdf
                :show-layout="true"
                :float-layout="false"
                :enable-download="false"
                :preview-modal="false"
                :filename="`Order_De_Compra.pdf`"
                :paginate-elements-by-height="1200"
                :pdf-quality="2"
                pdf-format="a4"
                pdf-orientation="portrait"
                pdf-content-width="695px"
                :manual-pagination="true"
                :htmlToPdfOptions = "htmlToPdfOptions"
                @progress="onProgress($event)"
                @startPagination="startPagination()"
                @hasPaginated="hasPaginated()"
                @beforeDownload="beforeDownload($event)"
                @hasDownloaded="hasDownloaded($event)" ref="html2Pdf">	
                    <section slot="pdf-content">
                        <v-container style="padding: 0%;" class="pdf-item">
                            <div>
                                <div class="logo-container">
                                    <img src="/static/logo_sp.png" alt="" class="logo">
                                </div>
                                <div style="display: flex; flex-direction: column;">
                                    <span style="font-size: 11px; font-weight: bold; letter-spacing: 0.3px;">SUNSHINE EXPORT S.A.C.</span>
                                    <span style="font-size: 9.5px;">Telf.: 073-368262 / 368031</span>
                                </div>
                            </div>

                            <div class="title">ORDEN DE COMPRA</div>

                            <div class="section">
                                <div style="flex: 1;">
                                    <div class="field">
                                        <div class="field-label_1" style="margin-left: 12px;">Sr. (es) :</div>
                                        <div style="max-width: 260px;">{{ orderLocal.SupName }}</div>
                                    </div>
                                    <br>
                                    <div class="field">
                                        <div class="field-label_1" style="margin-left: 19px;">R.U.C. :</div>
                                        <div style="max-width: 260px;">{{ orderLocal.RucCompany }}</div>
                                    </div>
                                    <div class="field">
                                        <div class="field-label_1">Dirección :</div>
                                        <div style="max-width: 260px;">{{ orderLocal.DirectionCompany }}</div>
                                    </div>
                                </div>
                                <div style="flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 2px;">
                                    <div class="field">
                                        <div class="field-label">Orden N° :</div>
                                        <div class="field-label_2">{{ orderLocal.DocNumSap }}</div>
                                    </div>
                                    <div class="field">
                                        <div class="field-label">Fecha :</div>
                                        <div class="field-label_2">{{ this.$fun.formatDateView(orderLocal.DocDate) }}</div>
                                    </div>
                                    <div class="field">
                                        <div class="field-label">N° Requerimiento :</div>
                                        <div class="field-label_2">{{ orderLocal.NumReq }}</div>
                                    </div>
                                    <div class="field">
                                        <div class="field-label">F. Requerimiento :</div>
                                        <div class="field-label_2">{{ this.$fun.formatDateView(orderLocal.ReqAuthorizationDate) }}</div>
                                    </div>
                                    <div class="field">
                                        <div class="field-label">Cotización N° :</div>
                                        <div class="field-label_2">{{ orderLocal.U_SYP_NCOTI }}</div>
                                    </div>
                                    <div class="field">
                                        <div class="field-label">Condición de Pago :</div>
                                        <div class="field-label_2">{{ orderLocal.PymntGroup }}</div>
                                    </div>
                                    <div class="field">
                                        <div class="field-label">N° Cuenta :</div>
                                        <div class="field-label_2">{{ orderLocal.DflAccount }}</div>
                                    </div>
                                    <div class="field">
                                        <div class="field-label">Banco :</div>
                                        <div class="field-label_2">{{ orderLocal.BankName }}</div>
                                    </div>
                                </div>
                            </div>

                            <table>
                                <thead>
                                    <tr v-if="orderLocal.DocType == 'I'">
                                        <th>#</th>
                                        <th>Código Item</th>
                                        <th>Cant.</th>
                                        <th>UM</th>
                                        <th>Descripción</th>
                                        <th>P.U</th>
                                        <!-- <th>% Dcto.</th> -->
                                        <th>Sub Total</th>
                                    </tr>
                                    <tr v-if="orderLocal.DocType == 'S'">
                                        <th>#</th>
                                        <th>Descripción</th>
                                        <th>P.U</th>
                                        <!-- <th>% Dcto.</th> -->
                                        <th>Sub Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="orderLocal.DocType == 'I'" style="break-inside: avoid;" v-for="(item, i) in orderLocal.Detail" :key="i">
                                        <td>{{ item.Line }}</td>
                                        <td>{{ item.ArtCode }}</td>
                                        <td>{{ new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.OddQuantity) }}</td>
                                        <td>{{ item.UnitMeasurement }}</td>
                                        <td style="width: 55%;">{{ item.OddDescription }}</td>
                                        <td>{{ new Intl.NumberFormat('es-PE', { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(item.PriceWithDiscount) }}</td>
                                        <!-- <td>{{ new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.OddDiscountPercentage) }}</td> -->
                                        <td style="height: auto;">
                                        <div style="display: flex; justify-content: space-between; align-items: stretch; height: 100%;">
                                            <span style="display: flex; align-items: center;">{{ item.TypeCurrencyName }}</span>
                                            <span style="display: flex; align-items: center;">{{ new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.OddAmount - item.OddTaxAmount) }}</span>
                                        </div>
                                        </td>
                                    </tr>
                                    <tr v-if="orderLocal.DocType == 'S'" style="break-inside: avoid;" v-for="(item, e) in orderLocal.Detail" :key="e">
                                        <td>{{ item.Line }}</td>
                                        <td style="width: 55%;">{{ item.OddDescription }}</td>
                                        <td>{{ new Intl.NumberFormat('es-PE', { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(item.PriceWithDiscount) }}</td>
                                        <!-- <td>{{ new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.DiscPrcnt) }}</td> -->
                                        <td style="height: auto;">
                                        <div style="display: flex; justify-content: space-between; align-items: stretch; height: 100%;">
                                            <span style="display: flex; align-items: center;">{{ item.TypeCurrencyName }}</span>
                                            <span style="display: flex; align-items: center;">{{ new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.OddAmount - item.OddTaxAmount) }}</span>
                                        </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style="display: flex; break-inside: avoid;">
                                <div style="flex: 1;">
                                    <div class="footer-notes">
                                        *Adjuntar a la entrega de mercadería copia de esta orden, guía de remisión y la factura en original.<br>
                                        *Sírvase anotar en la guía de remisión y la factura el N° de la orden de compra.<br>
                                        *La mercadería se recibirá en almacén, sujeta a nuestra verificación y aprobación.<br>
                                        *Datos para emitir la factura:
                                    </div>
        
                                    <div class="footer-details">
                                        - <span style="font-weight: bold;">Razón social:</span> SUNSHINE EXPORT SAC<br>
                                        - <span style="font-weight: bold;">RUC:</span> 20329725431<br>
                                        - <span style="font-weight: bold;">Dirección:</span> CAR. TAMBO GRANDE - LAS LOMAS KM 1077 + 179 M PIURA - PIURA - TAMBO GRANDE
                                    </div>
                                </div>
    
                                <div class="totals">
                                    <div class="total-row">
                                        <div class="total-label">Sub Total:</div>
                                        <div style="display: flex; justify-content: space-between; width: 100%;"><span style="flex: 1;">{{ orderLocal.TypeCurrencyName }}</span> <span>{{ (new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(orderLocal.OrdSubTotal)) }}</span></div>
                                    </div>
                                    <div class="total-row">
                                        <div class="total-label">Dcto:</div>
                                        <div style="display: flex; justify-content: space-between; width: 100%;"> <span>{{ (new Intl.NumberFormat('es-PE', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(orderLocal.OrdDiscountPercentage)) }} %</span> <span>{{ (new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(calculatedDiscount)) }}</span></div>
                                    </div>
                                    <div class="total-row">
                                        <div class="total-label">IGV:</div>
                                        <div style="display: flex; justify-content: space-between; width: 100%;"><span style="flex: 1;">{{ orderLocal.TypeCurrencyName }}</span> <span>{{ (new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(orderLocal.OrdTaxAmount)) }}</span></div>
                                    </div>
                                    <div class="total-row">
                                        <div class="total-label">Total:</div>
                                        <div style="display: flex; justify-content: space-between; width: 100%;"><span style="flex: 1;">{{ orderLocal.TypeCurrencyName }}</span> <span>{{ (new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(orderLocal.OrdTotal)) }}</span></div>
                                    </div>
                                </div>
                            </div>

                            <div class="footer-total" style="break-inside: avoid;">
                                SON: {{ numberToWords(String(orderLocal.OrdTotal? (orderLocal.OrdTotal).toFixed(2) : 0), orderLocal) }}
                            </div>

                            <div style="display: flex; gap: 10px; font-size: 10px; break-inside: avoid;">
                                <div style="font-weight: bold;">Observaciones:</div>
                                <div style="width: 60%;">{{  orderLocal.OrdObservation }}</div>
                            </div>

                            <div v-if="orderLocal.IsLogistic != 0" class="signature" style="break-inside: avoid;">
                                <img src="/static/firmaRosalina.png" alt="Firma">
                            </div>
                        </v-container>
                    </section>
                </vue-html2pdf>
            </v-container>
        </v-card>
    </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import qrCode from "vue-qr-generator";
import _sOrderPurchase from "../../../services/Logistics/OrderPurchaseService";

export default {

    props: {
        data: {
            type: Object,
            default: null,
        },
        value: null,
    },
    components: {
        VueHtml2pdf,
        qrCode
    },
    data() {
        return {
            orderLocal: {},
            htmlToPdfOptions: {
                margin: 0.5,
                filename: `Order_De_Compra.pdf`,
                jsPDF: {
                    unit: 'in',
                    format: 'a4',
                    orientation: 'portrait'
                },
                html2canvas: {
                    useCORS: true,
                    scale: 4,
                    letterRendering: true,
                },
            },
        }
    },
    computed: {
        calculatedDiscount() {
            if (this.orderLocal.OrdDiscountAmount !== undefined && this.orderLocal.OrdDiscountAmount !== null && this.orderLocal.OrdDiscountAmount > 0) {
                return this.orderLocal.OrdDiscountAmount;
            }
            if (this.orderLocal.OrdSubTotal && this.orderLocal.OrdDiscountPercentage) {
                const baseAmount = this.orderLocal.OrdSubTotal;
                return (baseAmount * this.orderLocal.OrdDiscountPercentage) / 100;
            }
            return 0;
        }
    },
    methods: {
        capitalize(str, capitalize = true) {
            if (capitalize) {
                return str.trim().split(/\s+/).map(palabra =>
                    palabra.charAt(0).toUpperCase() + palabra.slice(1).toLowerCase()
                ).join(" ");
            } else {
                return str.trim().split(/\s+/).map(palabra =>
                    palabra.toUpperCase()).join(" ");
            }
        },
        numberToWords(num, orden) {
            console.log("num", num, "orden", orden);
            const units = ["", "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE"];
            const tens = ["", "DIEZ", "VEINTE", "TREINTA", "CUARENTA", "CINCUENTA", "SESENTA", "SETENTA", "OCHENTA", "NOVENTA"];
            const specials = ["DIEZ", "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISÉIS", "DIECISIETE", "DIECIOCHO", "DIECINUEVE"];
            const hundreds = ["", "CIEN", "DOSCIENTOS", "TRESCIENTOS", "CUATROCIENTOS", "QUINIENTOS", "SEISCIENTOS", "SETECIENTOS", "OCHOCIENTOS", "NOVECIENTOS"];

            function convertHundreds(n) {
                if (n < 10) return units[n];
                if (n < 20) return specials[n - 10];
                if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " Y " + units[n % 10] : "");
                return hundreds[Math.floor(n / 100)] + (n % 100 ? " " + convertHundreds(n % 100) : "");
            }

            function convertNumber(n) {
                if (n === 0) return "CERO";
                if (n < 1000) return convertHundreds(n);
                if (n < 1000000) {
                    let thousands = Math.floor(n / 1000);
                    let remainder = n % 1000;
                    return (thousands === 1 ? "MIL" : convertHundreds(thousands) + " MIL") + (remainder ? " " + convertHundreds(remainder) : "");
                }
                return "NÚMERO DEMASIADO GRANDE";
            }

            const parts = num.split(".");
            const integerPart = parseInt(parts[0], 10);
            const decimalPart = parts.length > 1 ? parts[1] : "00";
            
            let moneda = orden.TypeCurrencyHelper2 || "SOLES";

            return `${convertNumber(integerPart)} CON ${decimalPart}/100 ${moneda}`;
        },
        downloadPdf() {
            console.log("Llama a funciona antes");
            setTimeout(() => {
                this.$refs.html2Pdf.generatePdf();
            }, 300);
        },
        onProgress(progress) {
            this.progress = progress;
            console.log(`PDF generation progress: ${progress}%`)
        },
        startPagination() {
            console.log(`PDF has started pagination`)
        },

        hasPaginated() {
            console.log(`PDF has been paginated`)
        },

        beforeDownload({ html2pdf, options, pdfContent }) {
            console.log(`On Before PDF Generation`)
            html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)
                    pdf.setFontSize(6)
                    // pdf.setTextColor(150)
                    pdf.text('INCORPORADO AL REGIMEN DE AGENTES DE RETENCION DE I.G.V RESOLUCION DE SUPERINTENDENCIA Nº 254-2005 A PARTIR DEL 01/02/2006', (pdf.internal.pageSize.getWidth() * 0.05), (pdf.internal.pageSize.getHeight() - 0.3))
                    pdf.setFontSize(7)
                    pdf.text('Página ' + i + ' de ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.90), (pdf.internal.pageSize.getHeight() - 0.2))
                }
            }).save()
        },
    },
    created() {
        console.log("this.value",this.value);
        if (this.value != null) {
        _sOrderPurchase
            .byID({ OrdID: this.value }, this.$fun.getUserID())
            .then((r) => {
            this.orderLocal = r.data;
            console.log("this.orderLocal",this.orderLocal);
            });
    }
    }
}
</script>

<style scoped>
.logo-container {
    display: flex;
    align-items: center;
    height: 39px;
    margin-bottom: 2px;
}
.logo{
    height: 39px;
}
.title {
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    margin: 0 0 10px;
}
.section {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}
.field {
    display: flex;
    width: 100%;
}
.field-label_1{
    font-weight: bold;
    margin-right: 5px;
    font-size: 9.5px;
}
.field-label {
    font-weight: bold;
    margin-right: 5px;
    font-size: 9.5px;
    min-width: 100px;
    text-align: right;
    flex: 1;
}
.field-label_2{
    flex: 1;
}
table {
    width: 695px;
    border-collapse: collapse;
    margin: 10px 0;
    font-size: 10px;
}
th, td {
    border: none;
    border-top: 1px solid #999;
    border-bottom: 1px solid #999;
    padding: 4px;
    text-align: left;
}
th {
    background-color: #f9f9f9;
}
.totals {
    width: 28%;
    font-size: 10px;
}
.total-row {
    display: flex;
    flex: 1;
    gap: 10px;
    margin-bottom: 5px;
}
.total-label {
    font-weight: bold;
    min-width: 60px;
    text-align: right;
}
.footer-notes {
    font-size: 8.1px;
}
.footer-details {
    margin-top: 5px;
    font-size: 9px;
}
.footer-total {
    font-weight: bold;
    font-size: 11px;
    margin: 9px 0;
}
.signature {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    width: 100%;
}
.signature img {
    width: 130px;
}
.signature-line {
    /* border-top: 1px dashed #000; */
    /* margin-top: 10px; */
    /* padding-top: 5px; */
    padding: 0;
    margin: 0;
    font-weight: bold;
    font-size: 11px;
    text-align: center;
}
</style>